// components/HeroImage.tsx
import Image from "next/image";

interface HeroImageProps {
  src: string;
  alt?: string;
  priority?: boolean;
}

export default function HeroImage({ src, alt = "", priority = false }: HeroImageProps) {
  return (
    <div className="relative w-full h-[30vh] overflow-hidden">
      {/* Background image */}
      <Image
        src={src}
        alt={alt}
        fill
        priority={priority}
        className="object-cover object-top" // Added object-top to align the image to the top
      />

      {/* White fade at bottom */}
      <div className="absolute inset-0 bg-gradient-to-t from-white via-white/40 to-transparent" />
    </div>
  );
}